export default {
  id: '6c0c15d403',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page ypw-page ypw-txnpage" data-name="transaction">\n\n    <div class="navbar ypw-appbar no-shadow">\n      <div class="navbar-bg"></div>\n      <div class="navbar-inner ypw-appbar__inner">\n        <div class="left">\n          <a href="#" class="link icon-only back no-ripple ypw-appbar__btn" aria-label="Back">\n            <svg class="ypw-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m14.5 5.5-6.5 6.5 6.5 6.5"/></svg>\n          </a>\n        </div>\n        <div class="title txn-title">Transaction History</div>\n      </div>\n    </div>\n\n    <div class="page-content ypw-txnpage__content">\n      <!-- history.js: filter chips (wallet list only, when there is more than\n           one kind of transaction), then one tappable row per transaction,\n           or an empty state -->\n      <div class="ypw-txnfilters hidden" role="toolbar" aria-label="Filter transactions"></div>\n      <div class="block-container txn-history">\n        <div class="list media-list no-chevron list-recent-txn no-hairlines ypw-txnlist">\n          <ul></ul>\n        </div>\n      </div>\n    </div>\n  </div>\n';
      return r;
    }(this);
  },
  styleScoped: false
};